
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchPage } from './fetch-page';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import get from 'lodash/get';

/**
 * `Prpos` type.
 */

type Props<T> = QueryObserverBaseResult<T, unknown>;

/**
 * `Options` type.
 */

type Options<T> = {
  initialData?: T,
  slug: string
};

/**
 * Action type.
 */

const actionType = ({ locale, slug }): string => {
  return `${locale}-page-${slug}`;
};

/**
 * `usePage` hook.
 */

function usePage<T>({ initialData, slug }: Options<T>): Props<T> {
  const { locale, query } = useRouter();
  const variables = useMemo(() => ({
    hasPreview: get(query, 'preview'),
    locale,
    slug
  }), [locale, query, slug]);

  const result = useQuery([actionType(variables), variables], () => {
    return fetchPage(variables);
  }, {
    initialData
  });

  return result;
}

/**
 * Export `usePage` hook.
 */

export default usePage;
